import { Component } from '@opten/compiler/metadata/component';
import {getParentWithClass} from '@opten/dom/get-parent-with-class'
import {removeClass} from '@opten/dom/remove-class';

@Component({ className: 'js-form-location-seller', observe: true })
export class FormLocationSellerComponent {

    loadingIndicator: string;
	contentElement: HTMLSelectElement;
	locationElement: HTMLSelectElement;
	formElement: HTMLFormElement;
    targetToLoad: string;
    language: string;

    constructor(private element: HTMLSelectElement) {
        this.contentElement = element;
        this.init();
    }

    init() {
        this.targetToLoad = this.contentElement.getAttribute('data-load');
        var dataLanguage = document.body.getAttribute('data-language-long');
        if (dataLanguage && dataLanguage.length > 0) {
            this.language = dataLanguage;
		}
		this.formElement = getParentWithClass(this.contentElement,'js-form') as HTMLFormElement;
		if(this.formElement){
			var locationElements = this.formElement.getElementsByClassName('js-form-location');
			if(locationElements && locationElements.length > 0){
				this.locationElement = locationElements[0] as HTMLSelectElement;
				this.handleLocationUpdated();
				this.locationElement.addEventListener('change', () => this.handleLocationUpdated());
			}
		}
    }
	private handleLocationUpdated(): void {
		const selectedLocation = this.locationElement.value;
		this.contentElement.selectedIndex = 0;
		const lengthLocationSellers = this.contentElement.options.length;
		for(let i = 1; i < lengthLocationSellers; i++){
			this.contentElement.remove(1);
		}
		removeClass(this.contentElement,'is-filled');

		this.handleLoadContent(selectedLocation);

	}

    private handleLoadContent(selectedLocation: string): void {
        fetch(this.targetToLoad, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept-language': this.language,
                // todo: why? if we change to a api controller we don't have this problem...
                'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
			},
			body: 'location='+selectedLocation,
            credentials: 'include'
        })
            .then(response => {
                const contentType = response.headers.get('content-type');
				if (contentType && (contentType.includes('text/html') || contentType.includes('text/plain'))) {
                    return response.text();
                }
            })
            .then(data => {
                this.handleDataContentResult(data);
            });
    }

    private handleDataContentResult(data: string) {
        if (data != null && data.length > 0) {
            this.contentElement.innerHTML = this.contentElement.innerHTML + data;
        }
    }


}